<template>
  <v-container fluid class="pa-0">
    <v-row v-if="!SearchQuery && PastSearches && PastSearches[0]" no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col cols="0">
            <h3 v-text="$t('servicesystem.common_objects.commonterms.prevoius_searches')" class="useThemeTextColor ml-3" />
          </v-col>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="close" v-bind="attrs" v-on="on" @click="clearSearchHistory()">
                  <v-icon size="20">mdi-close</v-icon>
                </v-btn>
              </template>
              <span v-text="$t('servicesystem.common_objects.commonterms.clear_search_history')" />
            </v-tooltip>

            <!--
            <v-btn icon
                  small
                  @click="hideSearches = !hideSearches">
              <v-icon v-text="hideSearches ? 'mdi-chevron-down' : 'mdi-chevron-up'"></v-icon>
            </v-btn>
          -->
          </v-col>
        </v-row>
        <v-list v-if="!hideSearches" dense class="py-0">
          <template v-for="searchterm in PastSearches">
            <v-hover v-slot="{ hover }" v-if="searchterm.type != 'searchresult'" :key="searchterm.query">
              <v-list-item link class="pr-0" @click="$emit('RedoSearch', searchterm.query)">
                <v-row no-gutters>
                  <v-col cols="10">
                    <v-list-item-title class="nowrapheader">
                      {{ searchterm.query }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="2">
                    <v-list-item-subtitle class="text-right">{{ i18nFormatDateTime(searchterm.stamp)
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-row>
                <v-list-item-action class="my-auto">
                  <v-btn icon color="close" small @click.stop="removeSearchFromHistory(searchterm.query)">
                    <v-icon v-if="hover" size="20">mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <!--
    <v-row no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col cols="0">
            <h3 v-text="'Previously clicked results'"
                class="useThemeTextColor ml-3" />
          </v-col>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon
                       small
                       color="close"
                       v-bind="attrs"
                       v-on="on"
                       @click="clearSearchHistory()">
                  <v-icon size="20">mdi-close</v-icon>
                </v-btn>
              </template>
              <span v-text="$t('servicesystem.common_objects.commonterms.clear_search_history')" />
            </v-tooltip>
          </v-col>
        </v-row>
        <v-list v-if="!hideSearches"
                dense
                class="py-0">
          <template v-for="searchterm in PastSearches">
            <v-hover v-slot="{ hover }"
                     v-if="searchterm.type == 'searchresult'"
                     :key="searchterm.query">
              <v-list-item link
                           class="pr-0"
                           @click="$emit('RedoSearch', searchterm.query)">
                <v-row no-gutters>
                  <v-col cols="0">
                    <v-list-item-title class="nowrapheader">
                      {{searchterm.query}}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="auto">
                    <v-list-item-subtitle>{{i18nFormatDateTime(searchterm.stamp)}}</v-list-item-subtitle>
                  </v-col>
                </v-row>
                <v-list-item-action class="my-auto">
                  <v-btn icon
                         small>
                    <v-icon v-if="hover">mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </template>
        </v-list>
      </v-col>
    </v-row>
    -->
  </v-container>
</template>


<script>
export default {
  name: "SearchHistory",
  props: {},
  components: {},
  mixins: [],

  data() {
    return {
      hideSearches: false,
    };
  },

  mounted() {},

  methods: {
    clearSearchHistory() {
      this.PastSearches = [];
    },

    removeSearchFromHistory(targetquery) {
      this.PastSearches = this.PastSearches.filter((x) => x.query != targetquery);
    },
  },

  computed: {
    PastSearches: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("GlobalSearchHistory");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "GlobalSearchHistory", value: update });
      },
    },

    SearchQuery() {
      return this.$store.state.globalSearchQuery;
    },
  },

  watch: {},
};
</script>


<style lang="scss">
</style>